// src/components/ManagedVenueList.js
import React from 'react';
import { useQuery, gql } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import './ManagedVenueList.css';

const GET_MANAGED_VENUES = gql`
  query GetManagedVenues {
    getManagedVenues {
      id
      name
      slug
    }
  }
`;

const ManagedVenueList = () => {
  const navigate = useNavigate();
  const token = sessionStorage.getItem('token');

  const { data, loading, error } = useQuery(GET_MANAGED_VENUES, {
    context: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  });

  if (loading) return <p>Loading venues...</p>;
  if (error) return <p>Error loading venues: {error.message}</p>;

  const venues = data.getManagedVenues || [];

  return (
    <div className="venue-list">
      <h2>Your Venues</h2>
      {venues.length === 0 ? (
        <p>You don't manage any venues yet.</p>
      ) : (
        <ul>
          {venues.map((venue) => (
            <li key={venue.id}>
              <button onClick={() => navigate(`/venuedashboard/${venue.id}`)}>
                {venue.name}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ManagedVenueList;
